import { getAccountDetailsFromURL } from '~/utils/utils';

/** True while RR is navigating from one account URL to a different account. */
export function isPendingAccountSwitch({
  navigationState,
  currentAccountId,
  currentAccountType,
  nextPathname,
}: {
  navigationState: 'idle' | 'loading' | 'submitting';
  currentAccountId?: string;
  currentAccountType?: string;
  nextPathname?: string | null;
}) {
  if (navigationState === 'idle' || !nextPathname) return false;
  const nextAccount = getAccountDetailsFromURL(nextPathname);
  return (
    !!nextAccount?.accountId &&
    !!nextAccount?.accountType &&
    (nextAccount.accountId !== currentAccountId || nextAccount.accountType !== currentAccountType)
  );
}
